import { createSelector } from "@reduxjs/toolkit";

import {
  assert,
  contentLanguagesSelector,
  getFallbackLanguageCodesCreate,
  primaryContentLanguageCodeSelector,
} from "@skilitics/nautilus-core-designer-data";

import { activeContentLanguageCodeSelector } from "./appConfigSelectors.ts";

export const getFallbackLanguageCodesSelector = createSelector(
  [primaryContentLanguageCodeSelector, contentLanguagesSelector],
  (primaryLanguageCode, contentLanguages) => getFallbackLanguageCodesCreate({ primaryLanguageCode, contentLanguages }),
);

export const fallbackLanguageCodesSelector = createSelector(
  [activeContentLanguageCodeSelector, getFallbackLanguageCodesSelector],
  (activeLang, getFallbackLanguageCodes) => getFallbackLanguageCodes(activeLang),
);

export const activeLanguageSelector = createSelector(
  activeContentLanguageCodeSelector,
  contentLanguagesSelector,
  (activeLang, contentLanguages) => {
    const contentLanguage = contentLanguages.find((lang) => lang.code === activeLang);
    assert(contentLanguage, `Language with code ${activeLang} not found`);
    return contentLanguage.language;
  },
);

export const languageCodesSelector = createSelector(
  [activeContentLanguageCodeSelector, primaryContentLanguageCodeSelector],
  (active, primary) => ({
    active,
    primary,
  }),
);
